import * as firebase from 'firebase'

/*
  This is just a regular javascript object and no longer is a store.
  It no longer is a store, instead it gets sent to the store file now.
*/
export default {
  // the store configuration
  state: {
    avatar: null
  },
  mutations: {  // changes the state of data properties
    setAvatar (state, payload) {
      state.avatar = payload
    }
  },
  /*
    Perform all asynchronous tasks in the actions area
   */
  actions: {  // to dispatch the mutations
    fetchAvatarData ({commit, getters}) {
      // commit('setLoading', true)

      // get user data from firebase using the getters
      // once fetches the data once.  It doesn't set up a permanent listener
      firebase.database().ref('/users/').child(getters.user.id).once('value', (data) => {
        let updatedAvatar = {
          didimoKey: data.child('didimoKey').val(),
          hasAvatar: data.child('hasAvatar').val()
        }
        commit('setAvatar', updatedAvatar)
      })
      .catch(error => {
        console.log(error)
        // commit('setLoading', false)
      })
    },

    //Modify Setters
    changeDidimoKey({commit, getters}, payload) {
      firebase.database().ref('/users/').child(getters.user.id).update({
        "didimoKey": payload
      })
      commit('setDidimoKey', {didimoKey: payload})
    },
    changeHasAvatar({commit, getters}, payload) {
      firebase.database().ref('/users/').child(getters.user.id).update({
        "hasAvatar": payload
      })
      commit('setHasAvatar', {hasAvatar: payload})
    },
  },
  getters: {  // get the store in pur components
    avatar (state) {  // return the user from vuex store
      return state.avatar
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/avatar/index.js